import * as _ from "lodash";
import POITypes from "@/enums/POITypes";
import moment from "moment-timezone";

const assetPropertiesMixin = {
	computed: {
		assetDetails() {
			return {
				AssetID: {
					value: this.asset.AssetID,
					copyButton: true
				},
				Artist: this.asset?.Artist || "-",
				Title: this.asset?.Title || "-",
				Album: this.asset?.Album || "-",
				Year: this.asset?.Year || "-",
				Label: this.asset?.Label || "-",
				ReleaseDate: moment(this.asset?.ReleaseDateTime).format("YYYY-MM-DD") || "-",
				GSelectorMediaID: {
					value: this.asset?.ThirdPartyIDs?.GSelector_MediaID || "-",
					copyButton: true
				},
				IHMProductID: {
					value: this.asset?.ThirdPartyIDs?.IHM_ProductID || "-",
					copyButton: true
				},
				MediaBaseID: {
					value: this.asset?.ThirdPartyIDs?.MediabaseID || "-",
					copyButton: true
				},
				MusicPointID: {
					value: this.asset?.ThirdPartyIDs?.MusicPointID || "-",
					copyButton: true
				}
			}
		},

		selectedStationMarkers() {
			return this.$store.getters.getAssetManagementSelectedStationMarkers();
		},

		markers() {
			return this.selectedStationMarkers ?? this.asset?.POIMarkup;
		},

		assetType() {
			return this.$store.getters.getAssetTypeById(this.asset?.AssetTypeID);
		},

		assetTypeDescription() {
			return this.$store.getters.getAssetTypeById(this.asset?.AssetTypeID)?.Description ?? "";
		},

		assetTypeIcon() {
			return `mdi-${this.$store.getters.getAssetTypeIcon(this.asset?.AssetTypeID) ?? "alert"}`;
		},

		assetTypeColor() {
			return this.$store.getters.getAssetTypeColor(this.asset?.AssetTypeID);
		},

		duration: function () {
			return this.asset?.POIMarkup?.Length;
		},

		intro() {
			const poiIntro = this.getLastPoiMarkerByType(POITypes.Intro);
			if (!poiIntro) {
				return null;
			}
			const fadeIn = this.fadeIn ?? 0;
			return poiIntro.Position - fadeIn;
		},

		outro() {
			const poiOutro = this.getLastPoiMarkerByType(POITypes.Segue);
			return poiOutro?.Position;
		},

		fadeIn() {
			const poiFadeIn = this.getLastPoiMarkerByType(POITypes.FadeIn);
			return poiFadeIn?.Position;
		},

		fadeInLength() {
			return this.getLastPoiMarkerByType(POITypes.FadeIn)?.Duration ?? 0;
		},

		fadeOut() {
			const poiFadeOut = this.getLastPoiMarkerByType(POITypes.FadeOut);
			return poiFadeOut?.Position;
		},

		fadeOutLength() {
			return this.getLastPoiMarkerByType(POITypes.FadeOut)?.Duration ?? 0;
		},

		segue() {
			const poiSegue = this.getLastPoiMarkerByType(POITypes.Segue);
			return poiSegue?.Position;
		},

		earlySegue() {
			const poiEarlySegue = this.getLastPoiMarkerByType(POITypes.EarlySegue);
			return poiEarlySegue?.Position;
		},

		hasAudio() {
			const length = this.event?.duration ?? this.markers?.Length;
			return length > 0;
		}
	},

	methods: {
		getLastPoiMarkerByType(poiMarkerType) {
			if (this.markers?.POIMarkers) {
				return _.maxBy(
					this.getPoiMarkersByType(this.markers?.POIMarkers, poiMarkerType),
					"Position"
				);
			}
			return null;
		},

		// updatePoiMarkersByType(poiMarkerType, poiMarkerPosition) {
		// 		if (this.markers?.POIMarkers) {
		// 			this.markers?.POIMarkers = this.updatePoiMarker(this.markers?.POIMarkers, poiMarkerType, poiMarkerPosition)
		// 		} else {
		// 			return null;
		// 		}
		// 	return this.markers?.POIMarkers;
		// },

		getPoiMarkersByType(poiMarkers, poiMarkerType) {
			return poiMarkers?.filter(poiMarker => poiMarker.POIType === poiMarkerType);
		},

		updatePoiMarker(poiMarkers, poiMarkerType, poiMarkerPosition) {
			if (!poiMarkers.find(marker => marker.POIType === poiMarkerType)) {
				poiMarkers.push({POIType: poiMarkerType})
			}
			poiMarkers.forEach(marker => {
				if (marker.POIType === poiMarkerType) {
					marker.Position = poiMarkerPosition
				}
			});
			return poiMarkers;
		},

		getStartEndDurationFromPOIMarkup(POIMarkup) {
			const fadeIn = this.getPoiMarkersByType(POIMarkup.POIMarkers, POITypes.FadeIn);
			const fadeOut = this.getPoiMarkersByType(POIMarkup.POIMarkers, POITypes.FadeOut);

			let startEndDuration = {
				start: fadeIn[0]?.Position ?? -1.0,
				end: !_.isNil(fadeOut[0]?.Position) ? fadeOut[0].Position + (fadeOut[0]?.Duration ?? 0) :
					 POIMarkup.Length ?? -1.0,
				duration: 0
			};

			if (startEndDuration.start >= 0 && startEndDuration.end >= 0) {// we have both start and end values
				startEndDuration.duration = startEndDuration.end - startEndDuration.start;
			}
			else {
				// start and/or end is not set
				if (startEndDuration.start < 0) {
					// start is not set
					if (startEndDuration.end >= 0) {	// end is set
						startEndDuration.duration = startEndDuration.end;
					}
					else {	// end is not set
						startEndDuration.duration = POIMarkup.Length;
					}
					startEndDuration.start = 0;
				}
				else {
					// start is set; which means end is not set
					startEndDuration.duration = POIMarkup.Length - startEndDuration.start;
				}
			}
			return startEndDuration;
		}
	}
}

export default assetPropertiesMixin;
